'use client';

import classNames from 'classnames';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

import { IImage } from 'app/interfaces/common';
import SwiperButtonPrev from 'app/components/common/SwiperButtonPrev';
import SwiperButtonNext from 'app/components/common/SwiperButtonNext';
import WithSwiper from 'app/components/common/WithSwiper';
import ImageBg from 'app/components/common/ImageBg';

export interface ISliderFullscreenProps {
  items: IImage[];
  className?: string;
}

export default function SliderFullscreen({
  items,
  className
}: ISliderFullscreenProps) {
  return (
    <div
      className={classNames('relative wrapper-max 4xl:wrapper-main', className)}
    >
      <Swiper
        spaceBetween={-12}
        breakpoints={{ 1920: { spaceBetween: 24 } }}
        className="4xl:rounded wrapper-main"
      >
        {items.map((item, index) => {
          return (
            <SwiperSlide key={index} className="wrapper-main 4xl:px-0">
              <div className="relative pb-[60%] md:pb-[50%] rounded h-full overflow-hidden group isolate">
                <div className="absolute inset-0 rounded group-hover:scale-105 transition-transform duration-700">
                  <ImageBg
                    src={item.url}
                    alt={item.alt || ''}
                    fill
                    className="object-cover rounded"
                    skeletonTheme="brown"
                    placeholderDataURL={item.placeholder_data_url}
                  />
                </div>
              </div>
            </SwiperSlide>
          );
        })}
        <WithSwiper>
          {({ isLocked }) =>
            !isLocked && (
              <div className="absolute bottom-3.5 md:bottom-6 right-7 md:right-12 z-10 flex gap-1 justify-end">
                <SwiperButtonPrev />
                <SwiperButtonNext />
              </div>
            )
          }
        </WithSwiper>
      </Swiper>
    </div>
  );
}
